// removed by extract-text-webpack-plugin
module.exports = {"root":"_2N2yx","img":"_3qhTB","title":"_2-SsH","description":"cs_6H","hideOnMobile":"_1Pwe6"};